<template>
  <tr>
    <td>
      {{ financeCode.code }}
    </td>
    <td>
      {{ financeCode.description }}
    </td>
    <td>
      <router-link class="btn btn-primary btn-sm" :to="'/contracts/finance-codes/edit/' + financeCode.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  components: {
  },
  name: 'FinanceCodeRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    financeCode () {
      return {
        ...this.object,
        ...this.updatedCode
      }
    }
  },
  data () {
    return {
      updatedCode: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/FinanceCode.vue